import { IncomingMessage } from "http";
import { buildExpressRequestPagesRouter } from "./express-request";
import { getStorePresentationInstance } from "./store-presentation-provider";

export const getKeyStoreDataversion = async (req: IncomingMessage) => {
  const store = getStorePresentationInstance();
  const { request } = await buildExpressRequestPagesRouter(req);
  const keyStoreDataversion = await store.getKeyStoreDataversion({
    request,
    response: {},
  });

  return keyStoreDataversion;
};
